import React from "react";
import { userDefinedFields } from "../formFields/asnTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function UserDefinedTab({ formData, onChange, formSubmissionAttempted }) {
  return (
    <GenericFormTab
      fields={userDefinedFields}
      formData={formData}
      onChange={onChange}
      formSubmissionAttempted={formSubmissionAttempted}
    />
  );
}
